// src/ConsumerApp/Screens/Home/components/BuilderTestimonials.js

import React, { useState } from 'react';
import UserCircle from '../../../../assets/icons/UserCircle.svg';

const TESTIMONIALS = [
  {
    id: 1,
    name: 'Chaitanya Gali',
    designation: 'Director, Lakshmi Alekhya Housing Pvt. Ltd',
    website: 'www.lahl.in',
    url: 'https://www.lahl.in/',
    image: '/images/pic_01.png',
    quote:
      'As a builder, time and reliability are everything, and Brickbucket delivers both. I used to spend hours coordinating with multiple suppliers; now, I do it all in a few clicks. It\'s like having a full procurement team in my pocket!',
  },
  {
    id: 2,
    name: 'Bhanu Kambala',
    designation: 'Founder, Minfa Projects',
    website: 'www.minfaprojects.com',
    url: 'https://www.minfaprojects.com/',
    image: '/images/pic_02.png',
    quote:
      'With Brickbucket, sourcing materials has never been easier. The app offers great prices, timely delivery, and real-time tracking—perfect for busy builders like us.',
  },
  {
    id: 3,
    name: 'Srinivas V. Varma',
    designation: 'Managing Partner, SVV Projects & Infra',
    website: 'www.svvinfra.com',
    url: 'https://www.svvinfra.com/',
    image: null,
    quote:
      'Site downtime during casting or plumbing stages used to cost us heavily. With Brickbucket\'s express delivery and verified GST billing, emergency replenishment is completely solved for our team.',
  },
];

function TestimonialAvatar({ src, name }) {
  const [hasError, setHasError] = useState(false);

  return (
    <div className="bb-testimonial-avatar-wrap">
      {src && !hasError ? (
        <img
          src={src}
          alt={name}
          className="bb-testimonial-avatar-img"
          onError={() => setHasError(true)}
          loading="lazy"
        />
      ) : (
        <div className="bb-testimonial-avatar-svg-wrap">
          <img src={UserCircle} alt="User" style={{ width: 42, height: 42, opacity: 0.7 }} />
        </div>
      )}
    </div>
  );
}

export default function BuilderTestimonials() {
  return (
    <section style={{ width: '100%' }}>
      <style>{`
        .testimonials-grid-container {
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 20px;
          width: 100%;
          padding-top: 32px;
          box-sizing: border-box;
        }

        .testimonial-card-item {
          background-color: #FFFFFF;
          border-radius: 16px;
          border: 1px solid #E2E8F0;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
          padding: 42px 20px 18px 20px;
          position: relative;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;
          box-sizing: border-box;
        }

        .testimonial-card-item:hover {
          transform: translateY(-2px);
          box-shadow: 0 8px 24px rgba(0, 0, 0, 0.07);
          border-color: #CBD5E1;
        }

        .bb-testimonial-avatar-wrap {
          width: 64px;
          height: 64px;
          border-radius: 32px;
          background-color: #FFFFFF;
          border: 3.5px solid #FFFFFF;
          box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
          overflow: hidden;
          position: absolute;
          top: -32px;
          left: 50%;
          transform: translateX(-50%);
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .bb-testimonial-avatar-img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          display: block;
        }

        .bb-testimonial-avatar-svg-wrap {
          width: 100%;
          height: 100%;
          background-color: #F8FAFC;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .bb-testimonial-quote {
          font-size: 13px;
          line-height: 20px;
          color: #334155;
          margin: 0 0 16px 0;
          text-align: left;
        }

        .bb-testimonial-author-box {
          margin-top: auto;
          display: flex;
          flex-direction: column;
          gap: 2px;
          padding-top: 12px;
          border-top: 1px solid #F1F5F9;
        }

        .bb-testimonial-author-name {
          font-size: 13.5px;
          font-weight: 800;
          color: #C7061F;
          margin: 0;
        }

        .bb-testimonial-author-desc {
          font-size: 11.5px;
          color: #64748B;
          line-height: 15px;
        }

        .bb-testimonial-author-link {
          font-size: 11.5px;
          font-weight: 600;
          color: #0F4392;
          text-decoration: underline;
          margin-top: 2px;
        }

        /* ── TABLET & MEDIUM SCREENS (<= 992px) ── */
        @media (max-width: 992px) {
          .testimonials-grid-container {
            display: flex;
            overflow-x: auto;
            gap: 16px;
            padding-top: 36px;
            padding-bottom: 8px;
            scroll-snap-type: x mandatory;
            scrollbar-width: none;
            -webkit-overflow-scrolling: touch;
          }

          .testimonials-grid-container::-webkit-scrollbar {
            display: none;
          }

          .testimonial-card-item {
            min-width: 290px;
            max-width: 320px;
            flex-shrink: 0;
            scroll-snap-align: start;
          }
        }

        /* ── MOBILE SCREENS (<= 480px) ── */
        @media (max-width: 480px) {
          .testimonial-card-item {
            min-width: 82vw;
            max-width: 82vw;
            padding: 38px 16px 16px 16px;
          }
          .bb-testimonial-quote {
            font-size: 12.5px;
            line-height: 19px;
          }
        }
      `}</style>

      <div className="bb-section-header">
        <h3 className="bb-section-title">Builder Testimonials</h3>
      </div>

      <div className="testimonials-grid-container">
        {TESTIMONIALS.map((t) => (
          <div key={t.id} className="testimonial-card-item">
            <TestimonialAvatar src={t.image} name={t.name} />
            <p className="bb-testimonial-quote">"{t.quote}"</p>

            <div className="bb-testimonial-author-box">
              <h4 className="bb-testimonial-author-name">{t.name}</h4>
              <span className="bb-testimonial-author-desc">{t.designation}</span>
              <a
                href={t.url}
                target="_blank"
                rel="noopener noreferrer"
                className="bb-testimonial-author-link"
              >
                {t.website}
              </a>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}